// features/organization/legalEntities/LegalEntitiesPage.jsx
import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import apiClient from "../../../shared/API/apiClient";
// import EntityModal from "./EntityModal";
import DeleteModal from "../../../shared/components/DeleteModal";
import Toast from "../../../shared/components/Toast";
import Pagination from "../../../shared/components/Pagination";
import usePagination from "../../../shared/hooks/usePagination";

const LegalEntities = () => {
  const [entities, setEntities] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  // const [showModal, setShowModal] = useState(false);
  // const [editRecord, setEditRecord] = useState(null);
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [toast, setToast] = useState(null);
  const user = JSON.parse(localStorage.getItem("user") ?? "{}");
  // const isAdmin = user?.role_name === "Admin";

  // ── Pagination ──────────────────────────────────────
  const {
    currentPage,
    totalPages,
    pageData,
    goToPage,
    setPageSize,
    pageSize,
    totalItems,
    startIndex,
    endIndex,
  } = usePagination(entities, 10);
  // ────────────────────────────────────────────────────

  const showToast = (message, type = "success") => setToast({ message, type });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchEntities = async () => {
      try {
        const response = await apiClient.get("/api/legal-entities");
        setEntities(response.data?.data ?? response.data ?? []);
      } catch(err) {
        console.error("Department fetch error:", err);
        showToast(err?.response?.data?.message || "Failed to load entities", "error");
        // silently fail
      } finally {
        setLoadingList(false);
      }
    };
    fetchEntities();
  }, []);
const openAdd = () => {
  navigate("/dashboard/legal-entities/entity-form/add");
};

const openEdit = (r) => {
  navigate(`/dashboard/legal-entities/entity-form/${r.entity_id}`);
};
  // const close = () => {
  //   setShowModal(false);
  //   setEditRecord(null);
  // };

  const handleSaved = (saved, response, wasEdit) => {
    setEntities((prev) => {
      const exists = prev.find(
        (e) => (e.id ?? e.entity_id) === (saved.id ?? saved.entity_id)
      );
      return exists
        ? prev.map((e) =>
            (e.id ?? e.entity_id) === (saved.id ?? saved.entity_id) ? saved : e
          )
        : [saved, ...prev];
    });
    showToast(
      response?.message || (wasEdit ? "Entity updated successfully!" : "Entity added successfully!"),
      "success"
    );
    // close();
  };

  const handleDeleted = (id, response) => {
    setEntities((prev) => prev.filter((e) => (e.id ?? e.entity_id) !== id));
    setDeleteRecord(null);
    showToast(response?.message ||"Entity deleted successfully.", "delete");
  };

  return (
    <div className="dash-page">
      <div className="le-page-header">
        <div>
          <div className="dash-page-title">Legal Entity Management</div>
          <div className="dash-page-subtitle">
            Manage subsidiaries, associates, and JVs as per BRSR Section A-III
          </div>
        </div>
        <button className="org-btn-save le-add-btn legal-btn" onClick={openAdd}>
          + &nbsp;Add Entity
        </button>
      </div>

      <div className="le-card">
        {loadingList ? (
          <div className="le-empty">
            <div className="le-empty-text">Loading entities…</div>
          </div>
        ) : entities.length === 0 ? (
          <div className="le-empty">
            <div className="le-empty-text">No legal entities added yet.</div>
            <button className="le-empty-btn" onClick={openAdd}>
              + &nbsp;Add your first entity
            </button>
          </div>
        ) : (
          <>
          <div className="table-wrap">
            <table className="le-table">
              <thead>
                <tr>
                  <th>Entity Name</th>
                  <th>CIN</th>
                  <th>PAN</th>
                  <th>Address</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {/* Use pageData instead of entities */}
                {pageData.map((e, i) => (
                  <tr key={e.id ?? e.entity_id ?? i}>
                    <td data-label="Entity Name" className="le-entity-name">{e.entity_name}</td>
                    <td data-label="CIN">{e.cin || "—"}
                      
                    </td>
                    <td data-label="PAN">
                    {e.pan || "—"}
                    </td>
                    <td data-label="Address">{e.address || "—"}</td>
                    <td data-label="Actions">
                      <div className="le-actions">
                        <span
                          className="action-item edit"
                          onClick={() => openEdit(e)}
                        >
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/1828/1828911.png"
                            alt="edit"
                            className="action-icon"
                          />
                          Edit
                        </span>

                        <span
                          className="action-item delete"
                          onClick={() => setDeleteRecord(e)}
                        >
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/1214/1214428.png"
                            alt="delete"
                            className="action-icon"
                          />
                          Delete
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            </div>

            {/* Pagination bar */}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={totalItems}
              startIndex={startIndex}
              endIndex={endIndex}
              onPageChange={goToPage}
              pageSize={pageSize}
              onPageSizeChange={setPageSize}
            />
          </>
        )}
      </div>
{/* 
      {showModal && (
        <EntityModal
          onClose={close}
          onSaved={handleSaved}
          editRecord={editRecord}
        />
      )} */}

      {deleteRecord && (
        <DeleteModal
          record={deleteRecord}
          idKey="entity_id"
          nameKey="entity_name"
          endpoint="/api/legal-entities"
          onClose={() => setDeleteRecord(null)}
          onDeleted={handleDeleted}
        />
      )}

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
};

export default LegalEntities;
